module.exports = __webpack_public_path__ + "static/contactushero-84e24f0e84129b4eb087321500fcbbdf.png";